/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import request, { ContentType, RequestParams } from './httpClient'
import {
  DomainListUserResp,
  DomainOAuthURLResp,
  DomainPermission,
  DomainSetPermissionReq,
  DomainUploadFileResp,
  GetAdminUserListParams,
  GetAdminUserLoginParams,
  PostAdminUploadFilePayload,
  WebResp,
} from './types'

/**
 * @description 上传文件
 *
 * @tags AdminV1
 * @name PostAdminUploadFile
 * @summary 上传文件
 * @request POST:/api/v1/admin/file/upload
 * @response `200` `(WebResp & {
    data?: DomainUploadFileResp,

})` OK
 */

export const postAdminUploadFile = (data: PostAdminUploadFilePayload, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainUploadFileResp
    }
  >({
    path: `/api/v1/admin/file/upload`,
    method: 'POST',
    body: data,
    type: ContentType.FormData,
    format: 'json',
    ...params,
  })

/**
 * @description 获取权限列表
 *
 * @tags AdminV1
 * @name GetAdminGetPermission
 * @summary 获取权限列表
 * @request GET:/api/v1/admin/permission
 * @response `200` `(WebResp & {
    data?: (DomainPermission)[],

})` OK
 */

export const getAdminGetPermission = (params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainPermission[]
    }
  >({
    path: `/api/v1/admin/permission`,
    method: 'GET',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 用户列表
 *
 * @tags AdminV1
 * @name GetAdminUserList
 * @summary 用户列表
 * @request GET:/api/v1/admin/user
 * @response `200` `(WebResp & {
    data?: DomainListUserResp,

})` OK
 */

export const getAdminUserList = (query: GetAdminUserListParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainListUserResp
    }
  >({
    path: `/api/v1/admin/user`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 登录
 *
 * @tags AdminV1
 * @name GetAdminUserLogin
 * @summary 登录
 * @request GET:/api/v1/admin/user/login
 * @response `200` `(WebResp & {
    data?: DomainOAuthURLResp,

})` OK
 */

export const getAdminUserLogin = (query: GetAdminUserLoginParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainOAuthURLResp
    }
  >({
    path: `/api/v1/admin/user/login`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 设置权限
 *
 * @tags AdminV1
 * @name PostAdminSetPermission
 * @summary 设置权限
 * @request POST:/api/v1/admin/user/permission
 * @response `200` `(WebResp & {
    data?: Record<string, any>,

})` OK
 */

export const postAdminSetPermission = (body: DomainSetPermissionReq, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: Record<string, any>
    }
  >({
    path: `/api/v1/admin/user/permission`,
    method: 'POST',
    body: body,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 更新用户状态
 *
 * @tags AdminV1
 * @name PutAdminUserStatus
 * @summary 更新用户状态
 * @request PUT:/api/v1/admin/user/{id}/status
 * @response `200` `WebResp` OK
 */

export const putAdminUserStatus = (id: number, body: { status: number }, params: RequestParams = {}) =>
  request<WebResp>({
    path: `/api/v1/admin/user/${id}/status`,
    method: 'PUT',
    body: body,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 设为管理员
 *
 * @tags AdminV1
 * @name PutAdminUserSetAdmin
 * @summary 设为管理员
 * @request PUT:/api/v1/admin/user/{id}/admin
 * @response `200` `WebResp` OK
 */

export const putAdminUserSetAdmin = (id: number, params: RequestParams = {}) =>
  request<WebResp>({
    path: `/api/v1/admin/user/${id}/admin`,
    method: 'PUT',
    format: 'json',
    ...params,
  })
